import Vue from "vue";
import VueAuth from "@websanova/vue-auth";
import bearer from "@websanova/vue-auth/drivers/auth/bearer";
import axios from "@websanova/vue-auth/drivers/http/axios.1.x";
import router from "@websanova/vue-auth/drivers/router/vue-router.2.x";
import vuerouter from "../app/app-routes";

Vue.router = vuerouter;

// Auth base configuration some of this options
// can be override in method calls
const config = {
  auth: bearer,
  http: axios,
  router: router,
  tokenDefaultName: "laravel-vue-spa",
  tokenStore: ["localStorage"],
  rolesVar: "permissions",
  registerData: { url: "/auth/register", method: "POST", redirect: "/login" },
  loginData: {
    url: "/api/login",
    method: "POST",
    redirect: { name: "dashboard.index" },
    fetchUser: true
  },
  logoutData: {
    url: "/api/logout",
    method: "GET",
    redirect: "/login",
    makeRequest: true
  },
  fetchData: { url: "/api/userdata", method: "GET", enabled: true },
  refreshData: {
    url: "/api/refresh",
    method: "GET",
    enabled: true,
    interval: 30
  }
};

Vue.use(VueAuth, config);
